<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav mat-elevation-z8" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false" style="background-color: #F2F2F2;">

    <!-- Liste des types de commerces -->
    <ng-container *ngIf="!selectedShopId || (isHandset$ | async)">
      <img src="./assets/logo-acal.png" alt="" style="height: 158px; margin: auto; display: block;" />

      <br />

      <!-- Evénements -->
      <mat-action-list style="background-color:white; padding-top: 0;" class="links">
        <mat-divider></mat-divider>
        <div mat-subheader>En ce moment</div>

        <a mat-list-item (click)="displayHalloween()" style="background-color: #FFAF1A;">
          <img matListIcon src="assets/pumpkin.svg" class="wiggle" />
          <div matLine style="color: white;">Grand Jeu d'Halloween</div>
        </a>
        <!--
        <a mat-list-item (click)="displayBraderie()" target="_blank">
          <img matListIcon style="border-radius: 0;" src="assets/clothing.svg" class="wiggle" />
          <div matLine>Jeu concours <i style="color: #F59E0B">&laquo; Braderie de Levallois &raquo;</i></div>
        </a>
        -->
        <a mat-list-item href="https://fr.calameo.com/read/000536966445c7a4fc2a1" target="_blank">
          <img matListIcon style="border-radius: 0;" src="assets/storytelling.svg" class="wiggle" />
          <div matLine>Guide Levallois Village 2021</div>
        </a>
        <!--
        <a mat-list-item href="https://jeu-concours.acal-levallois.fr" target="_blank">
          <img matListIcon style="border-radius: 0;" src="assets/pictures.svg" class="wiggle" />
          <div matLine>Jeu concours <i style="color: #F59E0B">&laquo; Levallois d'Antan &raquo;</i></div>
        </a>
        -->
        <!--
        <a mat-list-item (click)="displayHappyDays()">
          <img matListIcon style="border-radius: 0;" src="assets/happy-days/icon.svg" class="wiggle" />
          <div matLine>Grand Jeu à gratter <i style="color: #D94E8F">&laquo; Happy Days &raquo;</i></div>
        </a>
        -->
        <mat-divider></mat-divider>
      </mat-action-list>

      <br />

      <!-- Contacts -->
      <mat-action-list style="background-color: white; padding-top: 0;" class="links">
        <mat-divider></mat-divider>
        <div mat-subheader>Contact</div>

        <a mat-list-item href="https://www.facebook.com/associationcommercantsetartisanslevallois/" target="_blank">
          <img matListIcon src="assets/logo-facebook.png" />
          <div matLine>Page Facebook de l'ACAL</div>
        </a>

        <button mat-list-item (click)="displayContact()">
          <img matListIcon src="assets/bee.png" />
          <div matLine>Contacter l'ACAL</div>
        </button>

        <a mat-list-item class="update-shop" href="http://actualiser.acal-levallois.fr" target="_blank">
          <span matListIcon>
            <svg class="wiggle" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"></path>
            </svg>
          </span>
          <div matLine>Mettre à jour un commerce</div>
        </a>

        <mat-divider></mat-divider>
      </mat-action-list>

      <br />

      <!-- Sélection type de commerce -->
      <mat-action-list style="background-color: white; padding-top: 0;">
        <mat-divider></mat-divider>
        <div mat-subheader>Les commerçants de Levallois</div>
        <button mat-list-item [routerLink]="[ '/map' ]" [queryParams]="{  }" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="business-selected" (click)="closeDrawer()" style="border-color: #757575">
          <!-- <mat-icon matListIcon [svgIcon]="item.value.iconName || 'store'" [ngStyle]=" { 'color': '#' + item.value.color || '#757575' }"></mat-icon> -->
          <div matLine>Tous les commerçants</div>
        </button>

        <ng-container *ngFor="let item of businessSectors$ | async | keyvalue">
          <button mat-list-item [routerLink]="[ '/map' ]" [queryParams]="{ 'filterBy': item.key }" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="business-selected" #rla="routerLinkActive" (click)="closeDrawer()" [ngStyle]=" { 'border-color': '#' + item.value.color || '#757575' }">
            <mat-icon matListIcon [svgIcon]="item.value.iconName || 'store'" [ngStyle]=" { 'color': '#' + item.value.color || '#757575' }"></mat-icon>
            <div matLine>{{ item.key }}</div>
            <!-- <span *ngIf="rla.isActive" routerLink='/map' [queryParams]="{}" (click)="$event.stopPropagation()" style="position: absolute; top: 0; right: 10px; bottom: 0; display: flex; justify-content: center; align-items: center; color: #D0D0D0;">
              <mat-icon svgIcon="close-circle"></mat-icon>
            </span> -->
          </button>
          <mat-divider></mat-divider>
        </ng-container>
      </mat-action-list>
      <br />

      <!-- Selection marchés -->
      <mat-action-list style="background-color: white; padding-top: 0;">
        <mat-divider></mat-divider>
        <div mat-subheader>Les marchés de Levallois</div>
        <ng-container *ngFor="let item of markets">
          <button mat-list-item [routerLink]="['/markets', item]" routerLinkActive="business-selected" style="border-color: #757575" (click)="closeDrawer()">
            <mat-icon matListIcon svgIcon="storefront-outline" style="color: #757575"></mat-icon>
            <div matLine>{{item}}</div>
          </button>
          <mat-divider></mat-divider>
        </ng-container>
        <mat-divider></mat-divider>
      </mat-action-list>

      <br />

      <!-- Fournisseurs matériel COVID -->
      <mat-action-list style="background-color: white; padding-top: 0;">
        <mat-divider></mat-divider>
        <!-- <div mat-subheader>Liens utiles</div> -->

        <button mat-list-item [routerLink]="[ '/covid-partners' ]" (click)="closeDrawer()">
          <mat-icon matListIcon svgIcon="virus-outline" style="color: #757575"></mat-icon>
          <div matLine>Fournisseurs matériel COVID</div>
        </button>

        <mat-divider></mat-divider>
      </mat-action-list>

      <br />

      <!-- Campagne SMS -->
      <mat-action-list style="background-color: white; padding-top: 0;" class="links">
        <mat-divider></mat-divider>
        <div mat-subheader>Campagnes SMS commerçants</div>

        <a mat-list-item href="https://levallois-commerces-sms.fr/" target="_blank">
          <mat-icon matListIcon svgIcon="cellphone-message" style="color: #0061cf"></mat-icon>
          <div matLine>Plateforme d'envoi SMS</div>
        </a>
        <a mat-list-item href="assets/sms-manual-acal.pdf" target="_blank">
          <mat-icon matListIcon svgIcon="file-pdf" style="color: #bd0000"></mat-icon>
          <div matLine>Mode d'emploi plateforme d'envoi SMS</div>
        </a>

        <mat-divider></mat-divider>
      </mat-action-list>

      <br />

      <!-- Liens utiles -->
      <mat-action-list style="background-color: white; padding-top: 0;" class="links">
        <mat-divider></mat-divider>
        <div mat-subheader>Liens utiles</div>

        <a mat-list-item href="https://www.ville-levallois.fr/" target="_blank">
          <img matListIcon src="assets/logo-levallois.png" />
          <div matLine>Site de la Ville de Levallois</div>
        </a>

        <mat-divider></mat-divider>
      </mat-action-list>

      <br />
    </ng-container>

    <!-- Détails du marker sur PC -->
    <div *ngIf="selectedShopId && !(isHandset$ | async)">
      <app-shop-details [shopId]="selectedShopId"></app-shop-details>
      <button mat-mini-fab aria-label="Fermer" color="primary" style="position: absolute; top: 5px; right: 5px;" (click)="clearShopSelection()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <!-- Barre de nav sur mobile -->
    <mat-toolbar color="primary" *ngIf="isHandset$ | async" style="z-index: 1000;">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()" *ngIf="!selectedShopId && (isHandset$ | async)">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <button type="button" aria-label="Retour" mat-icon-button (click)="clearShopSelection()" *ngIf="selectedShopId && (isHandset$ | async)">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <span style="line-height: 1.2rem; margin-left: 1rem;">Association des commerçants<br />et des artisans de Levallois</span>
    </mat-toolbar>

    <router-outlet></router-outlet>

    <!-- Détails du commercants sur mobile -->
    <div *ngIf="selectedShopId && (isHandset$ | async)" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; z-index: 10; background-color: #F2F2F2;" [ngStyle]="{ 'top': (isHandset$ | async) ? '56px': '0' }">
      <app-shop-details [shopId]="selectedShopId"></app-shop-details>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>